import { jsx } from "react/jsx-runtime";
import * as React from "react";
import { c as clsx } from "../../../chunks/clsx-DF9QTL9H.js";
import { Icon } from "../../../foundations/icons/Icon.js";
const iconButton = "_iconButton_vch2l_1";
const styles = {
  iconButton,
  "iconButton-primary": "_iconButton-primary_vch2l_19",
  "iconButton-outline": "_iconButton-outline_vch2l_39",
  "iconButton-elevated": "_iconButton-elevated_vch2l_59",
  "iconButton-ghost": "_iconButton-ghost_vch2l_79"
};
const IconButtonBase = ({
  variant = "primary",
  icon = "XBig",
  onClick,
  className,
  ref,
  ...rest
}) => /* @__PURE__ */ jsx(
  "button",
  {
    className: clsx(styles.iconButton, styles["iconButton-" + variant], className),
    type: "button",
    onClick,
    ref,
    ...rest,
    children: /* @__PURE__ */ jsx(Icon, { variant: icon, "aria-hidden": true })
  }
);
const IconButton = React.forwardRef((props, ref) => /* @__PURE__ */ jsx(IconButtonBase, { ...props, ref }));
export {
  IconButton,
  IconButtonBase
};
